import { useTranslation } from 'react-i18next';
import type { ConsentOverviewCell } from '@/api/consents/consentsApi.types';
import { Badge } from '@/components/ui/badge';
import {
  CONSENT_STATUS_LABEL_KEY,
  CONSENT_STATUS_TONE,
  resolveConsentCellStatus,
} from './consentCellStatus';

export function ConsentStatusPill({ cell }: { cell: ConsentOverviewCell }) {
  const { t } = useTranslation('consents');
  const status = resolveConsentCellStatus(cell);
  return (
    <Badge
      tone={CONSENT_STATUS_TONE[status]}
      shape="tag"
      size="sm"
      uppercase
      className="text-[10px]"
    >
      {t(CONSENT_STATUS_LABEL_KEY[status])}
    </Badge>
  );
}
